import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    appCardTop,
    appCard,
    appLogo,
    cardContent,
    buttonRow,
    buttonSkip
} from './RegistrationLandingPage.css';
import GhostButton from './GhostButton';
//Please note that this page require a route similar to connect-user/t=x&r=y&c=z
// or the "An error has occurred" message will appear.
import lwLogo from '../../imgs/Logo.svg';
import Button from '../common/Button';

class RegistrationLandingPage extends Component {

    handelRedirect = e => {
        e.preventDefault();
        window.location.href = this.props.query.r;
    };

    render() {
        return (
            <div align="center" style={appCardTop} className="content">
                <div style={appCard}>
                    <div style={cardContent}>
                        <div>
                            <img src={lwLogo} style={appLogo} alt="" />
                        </div>
                        <h1 align="center">Lone Wolf Account Signup</h1>
                        <h3>Create or Link your Lone Wolf Account</h3>
                        <br />
                        <p>
                            {'"Lone Wolf Account" allows you to log in to all Lone Wolf Applications with a single ' +
                            'username and password.'}
                        </p>
                        <p>
                            If you already have a Lone Wolf Account (if you use an email address to log in to Back Office), select Link Account.
                        </p>
                        <p>
                            {'If you don\'t have a Lone Wolf Account, please select Create Account.'}
                        </p>
                        <div
                            className="row justify-content-center text-center"
                            style={buttonRow}
                        >
                            <div className="col-sm-2" />
                            <div className="col-sm-4">
                                <GhostButton
                                    path={'/register/sso-create/' + this.props.match.params.passedInfo}
                                    text={'Create Account'}
                                />
                            </div>
                            <div className="col-sm-4">
                                <GhostButton
                                    path={'/register/sso-link/' + this.props.match.params.passedInfo}
                                    text={'Link Account'}
                                />
                            </div>
                            <div className="col-sm-2" />
                        </div>
                    </div>
                    <div className="col-sm-4" style={buttonSkip}>
                        <Button
                            action={this.handelRedirect}
                            text={'Skip for Now'}
                        />
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = state => ({
    query: state.initial.queryInfo,
});

export default connect(mapStateToProps)(RegistrationLandingPage);
